/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled, useLayoutEffect, useRef, useState } from 'fierry/react';


const Container = styled.div`

  width: 100%;
  height: 100%;
`;


const useContainerSize = () =>
{
  const ref = useRef(null);

  const [ size, setSize ] = useState(null);

  useLayoutEffect(() =>
  {
    const observer = new ResizeObserver(entries =>
    {
      const { width, height } = entries[0].contentRect;

      setSize({ width: Math.floor(width), height: Math.floor(height) });
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return [ ref, size ];
};


export default ({ component: Component, ...props }) =>
{
  const [ ref, size ] = useContainerSize();

  return <Container ref = {ref}> {size && <Component {...props} width = {size.width} height = {size.height} />} </Container>;
};
